// Sentry init must run BEFORE bootstrapApplication — `Sentry.createErrorHandler`
// e `browserTracingIntegration` precisam estar prontos antes do primeiro
// componente renderizar.
import { initSentry } from './app/core/observability/sentry.config';
initSentry();

import { bootstrapApplication } from '@angular/platform-browser';

import { App } from './app/app';
import { appConfig } from './app/app.config';

bootstrapApplication(App, appConfig).catch((err: unknown) => {
  // eslint-disable-next-line no-console
  console.error(err);
});
